import styled from 'styled-components';

export const StatusWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-top: 2rem;
	color: ${({ theme }) => theme.colors.secondaryDark};

	${({ status, theme }) => (status === 'None' || status === 'Low') && `color: ${theme.colors.primaryDark}`};
	${({ status, theme }) => status === 'Medium' && `color: ${theme.colors.grayLighter2}`};

	svg {
		height: 2rem;
		width: auto;
		margin-right: 1rem;
	}
`;
